import * as types from "../constants/prayerFeatureActionTypes";
import { logUI } from "../api/andyliticsApi";
import * as Tools from "../helpers/Tools";

export const prayerFeatureInitialState = {
    token: null, userRole: null, memberId: null, connectionState: null, updating: null,
    livePrayers: null, liveMyPrayers: null, prayers: null, myPrayers: null, allComments: {}, comments: {},
    activeTab: '1', lastLoadTime: new Date(), error: null, hasError: false, hasPostError: false, hasBanWord: false
};

export default function prayerFeatureReducer(state = prayerFeatureInitialState, action) {
    let activityParam2 = null, activityStartTime = null;
    switch (action.type) {
        case types.SETUP_AMITY_USER_SESSION:
            state = prayerFeatureInitialState;
            break;
        case types.SETUP_AMITY_USER_SESSION_SUCCESS:
            state = { ...state, token: action.token, memberId: action.memberId, error: null };
            break;
        case types.SETUP_AMITY_USER_SESSION_FAILURE:
            state = { ...state, error: action.error };
            break;
        case types.RESET_PRAYER_FEATURE:
            state = prayerFeatureInitialState;
            break;
        case types.AMITY_CONNECTION_CHANGED:
            state = { ...state, connectionState: action.connectionState };
            break;
        case types.UPDATE_AMITY_USER_ROLE:
            state = { ...state, userRole: action.userRole };
            break;
        case types.PRAYER_WALL_TAB_CHANGED:
            state = { ...state, activeTab: action.activeTab };
            break;
        case types.GET_PRAYER_OF_THE_WEEK:
            state = { ...state, updatingPrayerOfTheWeek: true };
            break;
        case types.GET_PRAYER_OF_THE_WEEK_SUCCESS:
            state = { ...state, prayerOfTheWeek: action.prayers ? action.prayers[0] : null, livePrayerOfTheWeek: action.livePrayers, updatingPrayerOfTheWeek: false, prayerOfTheWeekHasError: false };
            break;
        case types.GET_PRAYER_OF_THE_WEEK_FAILURE:
            state = { ...state, prayerOfTheWeek: null, updatingPrayerOfTheWeek: false, prayerOfTheWeekHasError: true };
            break;
        case types.GET_USERS_DELETED_POSTS:
            state = { ...state, updatingUsersDeletedPosts: true };
            break;
        case types.GET_USERS_DELETED_POSTS_SUCCESS:
            const usersDeletedPosts = action.deletedPosts && action.deletedPosts.map(p => { return { userId: p.userId, reported: p.reportedCount, deleted: p.count, status: p.status }; });
            state = { ...state, usersDeletedPosts, updatingUsersDeletedPosts: false };
            break;
        case types.GET_USERS_DELETED_POSTS_FAILURE:
            state = { ...state, usersDeletedPosts: null, updatingUsersDeletedPosts: false };
            break;
        case types.GET_ALL_PRAYERS:
            state = { ...state, updating: true };
            break;
        case types.GET_ALL_PRAYERS_SUCCESS:
            state = { ...state, prayers: action.allPrayers, livePrayers: action.livePrayers, updating: false, hasError: false };
            if (action.sessionStartTime) {
                activityStartTime = action.sessionStartTime;
                delete action.sessionStartTime;
            }
            delete action.prayers; // dont' want to include it in kusto logs
            break;
        case types.UPDATE_LAST_LOAD_TIME:
            state = { ...state, lastLoadTime: new Date() };
            break;
        case types.GET_ALL_PRAYERS_FAILURE:
            state = { ...state, prayers: null, updating: false, hasError: true };
            break;
        case types.GET_MY_PRAYERS:
            state = { ...state, updatingMyPrayers: true };
            break;
        case types.GET_MY_PRAYERS_SUCCESS:
            state = { ...state, myPrayers: action.prayers, liveMyPrayers: action.livePrayers, updatingMyPrayers: false, myPrayersHasError: false };
            break;
        case types.GET_MY_PRAYERS_FAILURE:
            state = { ...state, myPrayers: null, updatingMyPrayers: false, myPrayersHasError: true };
            break;
        case types.POST_PRAYER:
            state = { ...state, updating: true, myRecentPrayerPostId: null, hasBanWord: false, hasPostError: false };
            break;
        case types.POST_PRAYER_SUCCESS:
            state = { ...state, updating: false, hasPostError: false, myRecentPrayerPostId: action.myRecentPrayerPostId, hasBanWord: false };
            activityParam2 = action.topic;
            break;
        case types.POST_PRAYER_FAILURE:
            state = { ...state, updating: false, hasPostError: true, hasBanWord: action.hasBanWord };
            break;
        case types.EDIT_PRAYER_SUCCESS:
            state = { ...state, myEditPrayerPostId: action.myEditPrayerPostId, textInput: action.textInput, hasBanWord: false, hasEditPrayerError: false };
            activityParam2 = action.myEditPrayerPostId;
            break;
        case types.EDIT_PRAYER_FAILURE:
            state = { ...state, hasEditPrayerError: true, hasBanWord: action.hasBanWord };
            break;
        case types.DELETE_PRAYER_SUCCESS:
            state = { ...state, isPrayerDeleted: true, deletedPrayer: action.prayer };
            activityParam2 = action.reasonForDelete;
            break;
        case types.DELETE_PRAYER_FAILURE:
            state = { ...state, isPrayerDeleted: false };
            break;
        case types.GET_COMMENT_SUCCESS:
            state.comments[action.commentId] = true;
            break;
        case types.GET_COMMENT_FAILURE:
            state.comments[action.commentId] = 'error';
            break;
        case types.GET_COMMENTS_SUCCESS:
            state.allComments[action.postId] = true;
            break;
        case types.GET_COMMENTS_FAILURE:
            state.allComments[action.postId] = 'error';
            break;
        case types.ADD_COMMENT_SUCCESS:
            state = { ...state, updating: false, commentHasError: false, myRecentComment: action.comment, commentHasBanWord: false };
            activityParam2 = action.comment.referenceId;
            break;
        case types.ADD_COMMENT_FAILURE:
            state = { ...state, updating: false, commentHasError: true, commentHasBanWord: action.commentHasBanWord };
            break;
        case types.EDIT_COMMENT_SUCCESS:
            state = { ...state, textInput: action.textInput, myRecentComment: action.comment, hasEditCommentError: false, hasBanWord: false };
            activityParam2 = action.comment.referenceId;
            break;
        case types.EDIT_COMMENT_FAILURE:
            state = { ...state, hasEditCommentError: true, hasBanWord: action.hasBanWord };
            break;
        case types.DELETE_COMMENT_SUCCESS:
            state = { ...state, isCommentDeleted: true, deletedComment: action.comment };
            activityParam2 = action.comment.referenceId;
            break;
        case types.DELETE_COMMENT_FAILURE:
            state = { ...state, isCommentDeleted: false };
            break;
        case types.GET_NOTIFICATION_BADGE_SUCCESS:
            state = { ...state, showBadge: action.showBadge, errorReadingBadge: null };
            break;
        case types.GET_NOTIFICATION_BADGE_FAILURE:
            state = { ...state, errorReadingBadge: action.error || 'error reading badge' };
            break;
        case types.POST_NOTIFICATION_BADGE_ASREAD_SUCCESS:
            state = { ...state, badgeResetResult: action.response, errorResetingBadge: null };
            break;
        case types.POST_NOTIFICATION_BADGE_ASREAD_FAILURE:
            state = { ...state, errorResetinggBadge: action.error || 'error resetting badge' };
            break;
        case types.ADD_PRAYER_REACTION_SUCCESS: case types.REMOVE_PRAYER_REACTION_SUCCESS:
        case types.ADD_COMMENT_REACTION_SUCCESS: case types.REMOVE_COMMENT_REACTION_SUCCESS:
            activityParam2 = action.postId;
            delete action.postId;
            break;
        case types.PRAYER_WALL_ENTERED:
            activityParam2 = action.timestamp;
            delete action.timestamp;
            break;
        case types.PRAYER_WALL_LEFT:
            activityParam2 = action.sessionDurationInMinutes;
            delete action.sessionDurationInMinutes;
            break;
        case types.GET_NEXT_PRAYERS:
            state = { ...state, loadingMore: true };
            break;
        case types.GET_NEXT_PRAYERS_COMPLETED:
            state = { ...state, loadingMore: action.gotMore ? state.loadingMore : false };
            break;
        case types.REFRESH_ALL_PRAYERS: case types.REFRESH_MY_PRAYERS:
        case types.EDIT_PRAYER: case types.DELETE_PRAYER:
        case types.GET_COMMENT: case types.GET_COMMENTS: case types.ADD_COMMENT: case types.EDIT_COMMENT: case types.DELETE_COMMENT:
        case types.ADD_PRAYER_REACTION: case types.ADD_PRAYER_REACTION_FAILURE:
        case types.REMOVE_PRAYER_REACTION: case types.REMOVE_PRAYER_REACTION_FAILURE:
        case types.ADD_COMMENT_REACTION: case types.ADD_COMMENT_REACTION_FAILURE:
        case types.REMOVE_COMMENT_REACTION: case types.REMOVE_COMMENT_REACTION_FAILURE:
        case types.GET_NOTIFICATION_BADGE: case types.POST_NOTIFICATION_BADGE_ASREAD:
        default:
            return state;
    }

    //const { ['type']: typeNotNeeded, ['callback']: callbackNotNeeded, ...restOfAction } = action;
    //let logData = JSON.stringify(restOfAction);
    //if (logData === JSON.stringify({})) {
    //    logData = null;
    //}
    //const memberId = sessionStorage['root'] ? JSON.parse(JSON.parse(sessionStorage['root']).prayerFeature).memberId : null;
    //logUI(action.type, activityStartTime || new Date(), Tools.getURLPath(), logData, memberId, activityParam2);

    return state;
}